import { TeamAccessDTO } from '../team/team-access.dto';
import { AccountListDTO } from '../account/account-list.dto';
import { PositionListDTO } from '../position/position-list.dto';

export class ContactDTO extends TeamAccessDTO {

    firstName: string;

    lastName: string;

    email: string;

    image: string;

    phone: string;

    cellPhone: string;

    twofactor: boolean;

    accounts: Array<AccountListDTO>;

    positions: Array<PositionListDTO>;

}
